require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-something-big-is-coming.json") })
        }
      }, "path---blog-something-big-is-coming");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-something-big-is-coming!./.cache/json/blog-something-big-is-coming.json
// module id = 1032
// module chunks = 231608221292675